import { Component, OnInit, ViewChild} from '@angular/core';
import {MatDialog as MatDialog, MatDialogConfig as MatDialogConfig} from '@angular/material/dialog';

@Component({
    selector: 'app-activity-cart',
    templateUrl: './activity-cart.component.html',
    styleUrls: ['./activity-cart.component.scss', './../activities-lite.component.scss'],
    standalone: false
})
export class ActivityCartComponent implements OnInit {
  @ViewChild('deleteConfirmationDialog')  deleteConfirmationDialog;
  constructor(public dialog: MatDialog) { }
  ngOnInit(): void {
    return;
  }
  getPopup() {
    const dialogConfig = new MatDialogConfig();
    this.dialog.open(this.deleteConfirmationDialog, dialogConfig);
  }
  onNoClick() {
    this.dialog.closeAll();
  }
  
  
}

